// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__39R4N","list":"BalanceDue_list__3aWSz","listRow":"BalanceDue_listRow__sZa5f","total":"BalanceDue_total__3qmCc"};